<template>
  <div class="related-block" v-if="products.length">
    <h3>{{messages.setProductsPlaceholder}}</h3>
    <div class="related-products">
      <div class="related-item" v-for="product in products">
        <a :href="product.detailPage">
          <img :src="product.picture.src" :alt="product.printName" :title="product.printName" />
        </a>
        <div class="related-info">
          <a class="related-name" :href="product.detailPage">{{ product.printName }}</a>
          <div class="related-price">
            <span class="old" v-if="product.price.printPriceOld">{{ product.price.printPriceOld }}</span>
            <span class="new">{{ product.price.printPrice }}</span>
          </div>
          <button class="add-btn" @click.prevent="addToBasket(product.id)">{{ messages.setBuyButton }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'BuyComplect',
    props: ['products', 'messages'],
    data() {
        return {
            settings: {
                products: this.products,
                messages: this.messages
            },
        }
    },
    methods: {
      addToBasket(productId) {
        this.$emit('addToBasket', productId);
      }
    }
}
</script>

<style lang="scss" scoped>
.related-block {
  margin-top: 25px;
  margin-right: -20px;

  h3 {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .related-products {
    display: flex;
    gap: 5px;
    overflow-x: auto;
  }

  .related-item {
    border: 1px solid #858585;
    flex: 0 0 150px;
    text-align: center;
    background: #fff;
    padding: 5px 3px;
  }

  .related-item img {
    width: 100%;
    border-bottom: 1px solid #eee;
  }

  .related-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 135px;
  }

  .related-name {
    font-size: 14px;
    font-weight: 400;
    margin-top: 24px;
    flex: 1;
    color: #000;
  }

  .related-price {
    font-size: 12px;
    margin-top: 6px;
    font-weight: 300;
    color: #000;
  }

  .related-price .old {
    text-decoration: line-through;
    color: #858585;
    margin-right: 5px;
  }

  .related-price .new {
    color: #000;
    font-weight: 600;
  }

  .add-btn {
    background: #fff;
    border: 1px solid #858585;
    padding: 5px 18px;
    font-size: 14px;
    cursor: pointer;
    margin-top: 12px;
    text-transform: uppercase;
    color: #000000;
    align-self: center;
  }
}
</style>